module.exports = __webpack_public_path__ + "img/produtos.7fb3abb0.svg";